import React from 'react'
import { observer } from 'mobx-react'
import { Sandwich, SandwichBun, SandwichContent } from 'components/Sandwich'
import TeamItem from './TeamItem'
import { useScrollOffsetSpring } from 'hooks/spring-hooks'
import TeamListHeader from './TeamListHeader'
import TeamListFooter from './TeamListFooter'
import { TeamListViewModel } from './TeamListViewModel'
import ScrollView from 'components/ScrollView'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: TeamListViewModel
  onCreateTeamRequest: () => void
  showCreateAction: boolean
}

export default observer(function TeamList({
  vm,
  onCreateTeamRequest,
  showCreateAction,
}: Props) {
  const scrollRef = React.useRef<HTMLDivElement | null>(null)
  const scrollOffset = useScrollOffsetSpring(scrollRef)
  return (
    <Sandwich stretch>
      <SandwichBun>
        <TeamListHeader vm={vm} scrollOffset={scrollOffset} />
      </SandwichBun>
      <SandwichContent>
        <ScrollView ref={scrollRef}>
          <div>
            {vm.teamItems.map((teamItem) => (
              <TeamItem
                key={teamItem.team.id || ''}
                vm={teamItem}
                active={teamItem.team.id === vm.currentTeam.id}
              />
            ))}
          </div>
          {showCreateAction && (
            <TeamListFooter onCreateClick={onCreateTeamRequest} />
          )}
        </ScrollView>
      </SandwichContent>
    </Sandwich>
  )
})
